module.exports = __webpack_public_path__ + "img/CT.Bridges.Superstructure_.Composite_Steel_&_Concrete_Bridge_-_Ladder_Deck_30m.Steel.7f132913.png";